export default {
  SET_IMAGE_DATA(state, data) {
    state.appLogo = data;
  },

  SET_IMAGE_DATA_PATH(state, appLogoPath) {
    state.appLogoPath = appLogoPath;
  },

  SET_BROWSER_IMAGE_DATA(state, data) {
    state.browserIcon = data;
  },

  SET_BROWSER_IMAGE_DATA_PATH(state, browserIconPath) {
    state.browserIconPath = browserIconPath;
  },
};
